export const setCookie = (name: string, value: string, minutes: number): void => {
  const expires = new Date();
  expires.setTime(expires.getTime() + minutes * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
};

export const getCookie = (name: string): string | null => {
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const setPinCookie = (pin: string): void => {
  setCookie('ppv_pin', pin, 15);
};

export const setDeviceTypeCookie = (deviceType: string): void => {
  setCookie('ppv_device_type', deviceType, 15);
};

export const getPinFromCookie = (): string | null => {
  return getCookie('ppv_pin');
};